import React from "react";
import Header from "../../components/Header";
import HeaderImage from "../../images/job-interview9.jpg";
import "./service.css";

const importAll = (r) => r.keys().map(r);
const images = importAll(require.context("../../images", false, /gallery\d+\.jpg$/));

const Service = () => {
  return (
    <>
      {/* Header Section */}
      <Header title="Our Services" image={HeaderImage}>
        We provide high-quality, efficient, and automated reference checks.
      </Header>

      {/* Service Description Section */}
      <section className="service__description">
        <div className="service__container">
          <h2>Our Services</h2>

          <div className="service__content">
            {/* Left Column - Services Description */}
            <div className="service__card">
              <div className="service__card-header">
                <h3>Pre-Screening Video</h3>
              </div>
              <div className="service__card-body">
                <ul>
                  <li>See candidate responses to pre formulated interview questions of
your choosing that provide you the opportunity to understand the
candidate's strengths and weaknesses in relation to the position.</li>
                  <li>Evaluate the candidates’s communication skills against the
requirements of the role.</li>
                  
                </ul>
              </div>
            </div>

            {/* Right Column */}
            <div className="service__card">
              <div className="service__card-header">
                <h3>Video-Based Reference</h3>
              </div>
              <div className="service__card-body">
                <ul>
                  <li>Move beyond traditional written references or AI-generated summaries.</li>
                  <li>Gain access to a recorded <em>one-on-one video conversation</em> with the candidate’s reference provider.</li>
                  <li>Ensure a more transparent and reliable hiring process.</li>
                  <li>The tone of response, facial expressions, and paused answers by the reference provider are all important indicators for evaluating the veracity of a reference.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery">
        <div className="gallery__container">
          {images.map((image, index) => (
            <article key={index} className="gallery__item">
              <img src={image} alt={`Gallery item ${index + 1}`} />
            </article>
          ))}
        </div>
      </section>
    </>
  );
};

export default Service;